import { render, staticRenderFns } from "./CurrentChainSummary.vue?vue&type=template&id=346274d7&scoped=true"
import script from "./CurrentChainSummary.vue?vue&type=script&lang=js"
export * from "./CurrentChainSummary.vue?vue&type=script&lang=js"
import style0 from "./CurrentChainSummary.vue?vue&type=style&index=0&id=346274d7&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346274d7",
  null
  
)

export default component.exports